/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ChangeRequestDraft({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M12 .9q-.348 0-.673.088a.6.6 0 1 0 .31 1.16 1.4 1.4 0 0 1 .726 0 .6.6 0 0 0 .31-1.16A2.6 2.6 0 0 0 12 .9M14.512 2.827a.6.6 0 0 0-1.16.31 1.4 1.4 0 0 1 0 .726.6.6 0 1 0 1.16.31 2.6 2.6 0 0 0 0-1.346M10.647 3.137a.6.6 0 1 0-1.159-.31 2.6 2.6 0 0 0 0 1.346.6.6 0 1 0 1.16-.31 1.4 1.4 0 0 1 0-.726M12.673 6.012a.6.6 0 0 0-.31-1.16 1.4 1.4 0 0 1-.726 0 .6.6 0 0 0-.31 1.16 2.6 2.6 0 0 0 1.346 0" /><path fill="currentColor" fillRule="evenodd" d="M12.6 8v1.97a2.601 2.601 0 1 1-1.2 0V8a.6.6 0 1 1 1.2 0m-2 4.5a1.4 1.4 0 1 1 2.8 0 1.4 1.4 0 0 1-2.8 0M4.6 9.97a2.601 2.601 0 1 1-1.2 0V6.03a2.601 2.601 0 1 1 1.2 0zm-2 2.53a1.4 1.4 0 1 1 2.798.002A1.4 1.4 0 0 1 2.6 12.5M4 2.1a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8" clipRule="evenodd" /></svg>;
}
;